import React, { useState } from "react";

//Momentjs
import moment from "moment";
import "moment/locale/pt-br";

//components
import IconButton from "./IconButton";

//icons
import {
  Trash2
} from "react-feather";

//api
import api from "../services/api";

//auth
import {
  useAuth
} from "../providers/auth";

//Sweet alert
import Swal from "sweetalert2";

export default function TagItem(props) {
  //auth
  const { user } = useAuth();

  const token = { headers: { "Authorization": "Bearer " + user.token } };

  const [loading, setLoading] = useState(false);

  let usersOption = props.tag.qtd > 1 ?
    props.tag.qtd + " usuários" : props.tag.qtd + " usuário";

  async function onDelete(id) {
    setLoading(true);

    try {
      const response = await api.delete("/tags/remove/" + id, token);

      if (response.data.error) {
        let icon = "error";
        let title = "Ocorreu um erro";
        let text = response.data.message;

        openAlert(icon, title, text);
      } else {
        props.onDelete(id);

        let icon = "success";
        let title = "Sucesso";
        let text = response.data.message;

        openAlert(icon, title, text);
      }
    } catch (error) {
      let icon = "error";
      let title = "Ocorreu um erro";
      let text = "Erro interno do servidor.";

      openAlert(icon, title, text);
    } finally {
      setLoading(false);
    }
  };

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: false,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer)
      toast.addEventListener("mouseleave", Swal.resumeTimer)
    }
  });

  const openAlert = (icon, title, text) => {
    Toast.fire({
      icon,
      title,
      text
    });
  };

  return (
    <li className="fk-table__item fk-table__item--body">
      <div className="fk-table__item-name fk-table__item-name--first">
        #{props.tag.name}
      </div>
      <div className="fk-table__item-name fk-table__item-name--second">
        {moment(props.tag.created_at).format("lll")}
      </div>
      <div className="fk-table__item-name fk-table__item-name--third">
        {usersOption}
      </div>
      <div className="fk-table__item-name fk-table__item-name--lastone">
        <IconButton
          type="button"
          variant="danger"
          loading={loading}
          disabled={props.deleteLoading}
          onClick={() => onDelete(props.tag.id)}>
          <Trash2 />
        </IconButton>
      </div>
    </li>
  );
}